import { createStoreConfig } from "./common";
import { Workbook, Dashboard } from "../analytics/dasboards";

const endpoints = {
    getItems: { method: "get", url: "/client_workbooks/clients" },
};

export const useClientWorkbooksStore = createStoreConfig<Workbook>(endpoints, "clientsWorkbook", {
    order_by: "name",
    in: "id__in",
    pk: "id",
    ilike: "name__ilike",
    sortOptions: { primarySortField: "name" }
})

